module.exports = __webpack_public_path__ + "img/arrow-down-s-fill.386353b8.svg";